export  default  {
  /**
   * 判断是否为空
   */
  isEmpty:function (value) {
    if (value === null || value === undefined || value === "") {
      return true;
    } else if ((value instanceof Number || typeof(value) === "number") && isNaN(value)) {
      return true;
    } else {
      return false;
    }
  },

  /**
   * 说明：格式化参数 fmt		"yyyy-MM-dd hh:mm:ss.S"
   */
  dateFormat: function (time,fmt) {
    var o = {
      "M+": time.getMonth() + 1, //月份
      "d+": time.getDate(), //日
      "h+": time.getHours(), //小时
      "m+": time.getMinutes(), //分
      "s+": time.getSeconds(), //秒
      "q+": Math.floor((time.getMonth() + 3) / 3), //季度
      "S": time.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length))}
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)))}
    }
    return fmt;
  },

  debounce: function(func, timeWait) {
    var timeout;
    return function () {
        var context = this, //使this正确指向
            args = arguments;  //处理事件对象event
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, timeWait);
    }
  }
};